import { TemplatesToolbar } from './templates-toolbar';
import { TemplatesTable } from './templates-table';
import { TemplatesTableError } from './TemplatesTableError';
import { TemplatesTableLoading } from './TemplatesTableLoading';
import styles from './templatesManager.module.css';
import { useTemplateListView } from './useTemplateListView';

export function TemplatesManager() {
  const view = useTemplateListView();

  if (view.isLoading) {
    return <TemplatesTableLoading />;
  }

  if (view.error) {
    return <TemplatesTableError error={view.error} />;
  }

  return (
    <div className={styles.listView}>
      <TemplatesToolbar {...view} />
      <TemplatesTable {...view} />
    </div>
  );
}
